<template>
  <el-dialog
    title="手动补偿"
    :visible.sync="dialogVisible"
    width="1200px"
    :before-close="handleClose"
    style="height: 70vh"
  >
    <div class="dialog-body">
      <myTable
        :selection="false"
        :page="page"
        :showpage="true"
        :operation="false"
        v-loading="isLoading"
        :table-data="tableData"
        :table-option.sync="tableOption"
        @page-change="getList"
        :expand="false"
      >
        <template slot-scope="scope" slot="withholdStatus">
          <span>{{ withholdStatusMap[scope.row.withholdStatus] }}</span>
          <span
            v-if="
              scope.row.withholdStatus === 'ERROR' ||
              scope.row.withholdStatus === 'FAIL'
            "
            >:{{ scope.row.message }}</span
          >
        </template>
        <!-- <template slot-scope="scope" slot="operation">
                    <el-button type="text" size="mini" @click="handleManualTransfer">手动转账</el-button>
                </template> -->
      </myTable>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取消</el-button>
      <el-button
        type="primary"
        @click="handleConfirm"
        size="small"
        :loading="transferLoading"
        >手动补偿</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import myTable from "@/components/myTable";
import {
  findOrderSettlementDetail,
  doFixOrderSettlement,
} from "@/api/businessManage";
export default {
  name: "ManualCompensationDialog",
  components: {
    myTable,
  },
  data() {
    return {
      dialogVisible: false,
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "分账对象", prop: "payeeShopName" },
        { label: "康贝号", prop: "payeeShopNo" },
        { label: "资金流出方", prop: "payerShopName" },
        { label: "流出方康贝", prop: "payerShopNo" },
        { label: "分账金额", prop: "payeeAmount" },
        { label: "分账状态", prop: "withholdStatus", slot: true },
      ],
      isLoading: false, //loading
      transferLoading: false, //转账loading
      relatedOrderCode: "",
      withholdStatusMap: {
        ERROR: "失败",
        FAIL: "失败",
        INIT: "分账中",
        SUCCESS: "成功",
      },
    };
  },
  methods: {
    getList() {
      this.isLoading = true;
      findOrderSettlementDetail({ orderCode: this.relatedOrderCode })
        .then((res) => {
          console.log(res);
          if (res && res.length > 0) {
            this.tableData = res || [];
            this.page.total = res.length;
          }
        })
        .catch(() => {
          this.isLoading = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleManualTransfer() {
      console.log("手动转账");
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
    },
    handleConfirm() {
      this.transferLoading = true;
      doFixOrderSettlement({
        orderCode: this.relatedOrderCode,
      })
        .then((res) => {
          this.$message.success("手动补偿成功");
          this.getList();
        })
        .catch(() => {})
        .finally(() => {
          this.transferLoading = false;
        });
    },
    handleClose() {
      this.tableData = [];
      this.dialogVisible = false;
    },
    publicOpen(item) {
      this.relatedOrderCode = item.relatedOrderCode;
      this.dialogVisible = true;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-footer {
}
.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
</style>
